module.exports = __webpack_public_path__ + "assets/svg/Icons/32/time-yellow-22d987.svg";